export const envs = {
  zsyYnTest: {
    env: 'zsyYnTest',
    webPort: '8020',
    hostName: 'cnpc.test.eloop.pro',
    apiAdr: 'http://127.0.0.1:8680',
    mapApi: 'http://127.0.0.1:8680',
    socketAdr: 'http://127.0.0.1:8680',
    remark: '测试'
  },
  zsyYnDomo: {
    env: 'zsyYnTest',
    webPort: '8020',
    hostName: 'cnpc.test.eloop.pro',
    apiAdr: 'https://api.oil.e-forward.cn',
    mapApi: 'https://api.oil.e-forward.cn',
    socketAdr: 'https://api.oil.e-forward.cn',
    remark: '测试'
  }
}

const initEnv = () => {
  return envs['zsyYnDomo']
}

export default initEnv()



// WEBPACK FOOTER //
// ./src/env/envs.js